import type { AppListenerMiddleware } from "@src/store/rootState";
import { handleAiChatAction } from "@src/store/slices/aiChat";
import { vivStreamAction } from "@src/store/slices/experienceBuilder/ai/actions";

import { detectContinuation } from "../continuation/detect";
import { handlers } from "../continuation/handlers";
import { runContinuationSequence } from "../continuation/runContinuationSequence";

/**
 * Single orchestrator for the Viv chat stream. Every message arrives as a
 * `vivStreamAction` (dispatched by `useVivChatBridge`). For each one we forward
 * it to the chat UI, then run the continuation sequence that fires the next
 * turn — driven either by a turn-ending tool's ui-action output, or by a parked
 * `execution: "client"` tool call awaiting its result.
 */
export function setupAiSideEffectListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: vivStreamAction,
    effect: async (action, api) => {
      const { data } = action.payload;

      // Forward to the chat reducer + experience-creation ui-action listener
      // (both key on `handleAiChatAction`).
      api.dispatch(handleAiChatAction(data));

      const detected = detectContinuation(data, handlers);
      if (detected) {
        await runContinuationSequence(detected, api);
      }
    },
  });
}
